import React from 'react'
import { Row, Col, Divider } from 'antd'
import learn from '../../assets/images/learn.svg'
import ImagePath from './Image'
import VideoTitle from './video'
class Step extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      video: [],
      number: 0,
      time: 0,
      view: 0,
      viewid: []
    }
  }
  componentDidMount() {
    var url = new URL(process.env.REACT_APP_API+'/view/videolist'),
      params = { lid: this.props.lid ? this.props.lid : 1 }
    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key])
    )
    const videoData = fetch(url)
      .then((res) => res.json())
      .catch((error) => {
        console.error('Error', error)
      })
    let url2 = new URL(process.env.REACT_APP_API+'/view/watch'),
      params2 = { uid: 21313,lid:this.props.lid }
    Object.keys(params2).forEach((key) => {
      url2.searchParams.append(key, params2[key])
    })
    const viewData = fetch(url2)
      .then((res) => res.json())
      .catch((error) => console.log)

    Promise.all([videoData, viewData]).then((response) => {
      let timeval = (response[0].time / 3600).toFixed(1)
      let viewids = [];
      response[1].data.forEach((item, index)=> {
        viewids.push(item.vid)
      })
      this.setState({
        video: response[0].video,
        number: response[0].number,
        time: timeval,
        view: (response[1].views / response[0].number).toFixed(1) * 100,
        viewid: viewids
      })
      
    }).catch((error)=>console.log)
  }
  render() {
    return (
      <div className={'container ' + this.props.direction + " " + (this.state.view > 0 ? (this.state.view < 100 ? "active start":"active end" ) : "")}>
        <div className="content">
          <div className="step">
            <div className="stepTitle">
              <Row justify="space-between">
                <Col
                  xl={{ span: 14, order: 1 }}
                  lg={{ span:15, order: 3 }}
                  style={{ textAlign: 'left' }}
                >
                  <h2>{this.props.title}</h2>
                  <p>{this.props.description}</p>
                  <Row className="fs-1">
                    <Col md={10}>
                      <img src={learn} alt="React Logo" />共{this.state.number}
                      節課
                    </Col>
                    <Col md={14}>
                      <img src={learn} alt="React Logo" />
                      預計用時{this.state.time}小時
                    </Col>
                  </Row>
                </Col>
                <Col xl={{ span: 9, order: 2 }} lg={{ order: 1 }}>
                  <ImagePath
                    percent={this.state.view}
                    image={
                      this.state.view
                        ? this.props.imageView
                        : this.props.imageNotView
                    }
                  />
                </Col>
              </Row>
            </div>
            <Divider className="stepdivider" />
            <div className="stepcontent">
              <VideoTitle
                videolist={this.state.video}
                id={this.props.id}
                lid={this.props.lid}
                viewid={ this.state.viewid}
                path={this.props.path}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Step
